import { defineComponent as _defineComponent } from 'vue'
interface Props {
  labelText: string;
  count: number;
  checked: boolean;
}

interface Emits {
  (event: 'filter:update', label: string, e: Event): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterItem',
  props: {
    labelText: null,
    count: null,
    checked: { type: Boolean }
  },
  emits: ["filter:update"],
  setup(__props: any) {




return { __sfc: true, }
}

})